import {isAndroid, isIOS} from 'react-device-detect';
import {androidStoreUrl, countryCodeFromTimezone, iosStoreUrl} from 'utils';

const redirectToAppOrDownload = () => {
  const countryCode = countryCodeFromTimezone();
  let deepLinkUrl = `abnk://${countryCode}`;
  if (window.location.pathname !== "/") {
    deepLinkUrl = `abnk:/${window.location.pathname}${window.location.search}`;
  }
  const storeUrl = isAndroid ? androidStoreUrl() : isIOS ? iosStoreUrl(countryCode) : '';

  window.location.replace(deepLinkUrl);

  setTimeout(() => {
    if (storeUrl) window.location.replace(storeUrl);
  }, 100);
};

export default redirectToAppOrDownload;
